import { MEDANTE_ICONS_ENUM } from '@/types'

import iconClientCenter from '../assets/medante-icons/icon-client-center.svg'
import iconHealthEducation from '../assets/medante-icons/icon-health-education.svg'
import iconLaboratory from '../assets/medante-icons/icon-laboratory.svg'
import iconMan from '../assets/medante-icons/icon-man.svg'
import iconOk from '../assets/medante-icons/icon-ok.svg'
import iconPersonalDevelopment from '../assets/medante-icons/icon-personal-development.svg'
import iconPrevention from '../assets/medante-icons/icon-prevention.svg'
import iconService1 from '../assets/medante-icons/icon-service-1.svg'
import iconService2 from '../assets/medante-icons/icon-service-2.svg'
import iconService3 from '../assets/medante-icons/icon-service-3.svg'
import iconService4 from '../assets/medante-icons/icon-service-4.svg'
import iconTooth from '../assets/medante-icons/icon-tooth.svg'
import iconWoman from '../assets/medante-icons/icon-woman.svg'
import iconXMarkBlue from '../assets/medante-icons/icon-x-mark-blue.svg'
import iconXMarkCyclamen from '../assets/medante-icons/icon-x-mark-cyclamen.svg'

export const iconsMap: Record<MEDANTE_ICONS_ENUM, string> = {
	[MEDANTE_ICONS_ENUM.HEALTH_EDUCATION]: iconHealthEducation,
	[MEDANTE_ICONS_ENUM.CLIENT_CENTER]: iconClientCenter,
	[MEDANTE_ICONS_ENUM.X_MARK_BLUE]: iconXMarkBlue,
	[MEDANTE_ICONS_ENUM.X_MARK_CYCLAMEN]: iconXMarkCyclamen,
	[MEDANTE_ICONS_ENUM.LABORATORY]: iconLaboratory,
	[MEDANTE_ICONS_ENUM.MAN]: iconMan,
	[MEDANTE_ICONS_ENUM.WOMAN]: iconWoman,
	[MEDANTE_ICONS_ENUM.OK]: iconOk,
	[MEDANTE_ICONS_ENUM.PERSONAL_DEVELOPMENT]: iconPersonalDevelopment,
	[MEDANTE_ICONS_ENUM.PREVENTION]: iconPrevention,
	[MEDANTE_ICONS_ENUM.SERVICE_1]: iconService1,
	[MEDANTE_ICONS_ENUM.SERVICE_2]: iconService2,
	[MEDANTE_ICONS_ENUM.SERVICE_3]: iconService3,
	[MEDANTE_ICONS_ENUM.SERVICE_4]: iconService4,
	[MEDANTE_ICONS_ENUM.TOOTH]: iconTooth
}
